// src/services/customer.service.ts
import api from './api';

export const getCustomerProfile = async () => {
  const response = await api.get('/cAuth/profile');
  return response.data;
};

export const updateCustomerProfile = async (data: {
  firstName?: string;
  lastName?: string;
  mobileNumber?: string;
  country?: string;
  state?: string;
  city?: string;
  bio?: string;
}) => {
  const response = await api.put('/cAuth/profile', data);
  return response.data;
};

export const uploadCustomerAvatar = async (formData: FormData) => {
  const response = await api.post('/cAuth/profile/avatar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getNotificationPreferences = async () => {
  const response = await api.get('/cAuth/notifications');
  return response.data;
};

export const updateNotificationPreferences = async (preferences: object) => {
  const response = await api.put('/cAuth/notifications', { preferences });
  return response.data;
};

export const deleteCustomerAccount = async () => {
  const response = await api.delete('/cAuth/account');
  return response.data;
};